export const Support = () => {
  return (
    <>
      Support
    </>
  )
}